export const menClothes = [
  {
    id: 1,
    title: "Gucci T-Shirts Classics",
    price: 109.95,
    description:
      "Your perfect pack for everyday use and walks in the forest. Stash your laptop (up to 15 inches) in the padded sleeve, your everyday",
    category: "men's clothing",
    image:
      "https://www.engelhorn.de/dw/image/v2/AALR_PRD/on/demandware.static/-/Sites-engelhorn-master-plattform/default/dw6a355b76/images/P10/00/21/8H/V1000334D/engelhorn-Gucci-Herren-T-Shirt-Vorderansicht-V1000334D-v1.jpg",
    rating: {
      rate: 4.5,
      count: 120,
    },
  },
  {
    id: 2,
    title: "Mens Casual Premium Slim Fit Shirts ",
    price: 22.3,
    description:
      "Slim-fitting style, contrast raglan long sleeve, three-button henley placket, light weight & soft fabric for breathable and comfortable wearing. And Solid stitched shirts with round neck made for durability and a great fit for casual fashion wear and diehard baseball fans. The Henley style round neckline includes a three-button placket.",
    category: "men's clothing",
    image:
      "https://sc01.alicdn.com/kf/HTB1eD8.PrvpK1RjSZPiq6zmwXXaT/New-formal-shirts-and-pants-combination-luxury.jpg",
    rating: {
      rate: 4,
      count: 259,
    },
  },
  {
    id: 3,
    title: "Mens Casual Slim Fit Shirts ",
    price: 22.3,
    description:
      "Slim-fitting style, contrast raglan long sleeve, three-button henley placket, light weight & soft fabric for breathable and comfortable wearing. And Solid stitched shirts with round neck made for durability and a great fit for casual fashion wear and diehard baseball fans. The Henley style round neckline includes a three-button placket.",
    category: "men's clothing",
    image:
      "https://sc01.alicdn.com/kf/HTB1eD8.PrvpK1RjSZPiq6zmwXXaT/New-formal-shirts-and-pants-combination-luxury.jpg",
    rating: {
      rate: 4.1,
      count: 259,
    },
  },

  {
    id: 4,
    title: "Mens Casual Slim Fit",
    price: 15.99,
    description:
      "The color could be slightly different between on the screen and in practice. / Please note that body builds vary by person, therefore, detailed size information should be reviewed below on the product description.",
    category: "men's clothing",
    image: "https://sc02.alicdn.com/kf/H3453c88eedb3428983fc8b5b7bb5f4d7J.jpg",
    rating: {
      rate: 2,
      count: 430,
    },
  },
  {
    id: 86,
    title: "Mens Casual Slim Fit",
    price: 15.99,
    description:
      "The color could be slightly different between on the screen and in practice. / Please note that body builds vary by person, therefore, detailed size information should be reviewed below on the product description.",
    category: "men's clothing",
    image:
      "https://sc02.alicdn.com/kf/H3554a8539bd947d5a9d682275d7c667bb/formal-shirts-and-pants-combination-men-formal.png",
    rating: {
      rate: 2,
      count: 430,
    },
  },
  {
    id: 87,
    title: "Harley Davidson t Shirt",
    price: 15.99,
    description:
      "The color could be slightly different between on the screen and in practice. / Please note that body builds vary by person, therefore, detailed size information should be reviewed below on the product description.",
    category: "men's clothing",
    image: "https://m.media-amazon.com/images/I/610KY73m3wL._AC_UX342_.jpg",
    rating: {
      rate: 2.1,
      count: 430,
    },
  },

  {
    id: 88,
    title: "Mens Casual Slim Fit",
    price: 15.99,
    description:
      "The color could be slightly different between on the screen and in practice. / Please note that body builds vary by person, therefore, detailed size information should be reviewed below on the product description.",
    category: "men's clothing",
    image:
      "https://sc02.alicdn.com/kf/H3554a8539bd947d5a9d682275d7c667bb/formal-shirts-and-pants-combination-men-formal.png",
    rating: {
      rate: 2,
      count: 430,
    },
  },
  {
    id: 89,
    title: "Mens Bomber Jacket",
    price: 15.99,
    description:
      "The color could be slightly different between on the screen and in practice. / Please note that body builds vary by person, therefore, detailed size information should be reviewed below on the product description.",
    category: "men's clothing",
    image:
      "https://i0.wp.com/ae01.alicdn.com/kf/HTB1L07xiaQoBKNjSZJnq6yw9VXaI/-font-b-Men-b-font-jeans-font-b-jacket-b-font-brand-new-fashion-font.jpg",
    rating: {
      rate: 2.1,
      count: 430,
    },
  },
  {
    id: 90,
    title: "Mens Nike Down Jacket",
    price: 15.99,
    description:
      "The color could be slightly different between on the screen and in practice. / Please note that body builds vary by person, therefore, detailed size information should be reviewed below on the product description.",
    category: "men's clothing",
    image:
      "https://i.pinimg.com/originals/60/7e/4b/607e4b842a727c3492b4f13498cc5fef.jpg",
    rating: {
      rate: 2.1,
      count: 430,
    },
  },
];

export const womenClothes = [
  {
    id: 5,
    title: "BIYLACLESEN Snowboard Coats",
    price: 56.99,
    description:
      "Note:The Jackets is US standard size, Please choose size as your usual wear Material: 100% Polyester; Detachable Liner Fabric: Warm Fleece. Detachable Functional Liner: Skin Friendly, Lightweigt and Warm.Stand Collar Liner jacket, keep you warm in cold weather. Zippered Pockets: 2 Zippered Hand Pockets, 2 Zippered Pockets on Chest (enough to keep cards or keys)and 1 Hidden Pocket Inside.Zippered Hand Pockets and Hidden Pocket keep your things secure. Humanized Design: Adjustable and Detachable Hood and Adjustable cuff to prevent the wind and water,for a comfortable fit. 3 in 1 Detachable Design provide more convenience, you can separate the coat and inner as needed, or wear it together. It is suitable for different season and help you adapt to different climates",
    category: "women's clothing",
    image: "https://fakestoreapi.com/img/51Y5NI-I5jL._AC_UX679_.jpg",
    rating: {
      rate: 2.6,
      count: 235,
    },
  },
  {
    id: 6,
    title: "Removable Hooded Leather",
    price: 29.95,
    description:
      "100% POLYURETHANE(shell) 100% POLYESTER(lining) 75% POLYESTER 25% COTTON (SWEATER), Faux leather material for style and comfort / 2 pockets of front, 2-For-One Hooded denim style faux leather jacket, Button detail on waist / Detail stitching at sides, HAND WASH ONLY / DO NOT BLEACH / LINE DRY / DO NOT IRON",
    category: "women's clothing",
    image: "https://fakestoreapi.com/img/81XH0e8fefL._AC_UY879_.jpg",
    rating: {
      rate: 2.9,
      count: 340,
    },
  },
  {
    id: 7,
    title: "Rain Jacket Women",
    price: 39.99,
    description:
      "Lightweight perfet for trip or casual wear---Long sleeve with hooded, adjustable drawstring waist design. Button and zipper front closure raincoat, fully stripes Lined and The Raincoat has 2 side pockets are a good size to hold all kinds of things, it covers the hips, and the hood is generous but doesn't overdo it.Attached Cotton Lined Hood with Adjustable Drawstrings give it a real styled look.",
    category: "women's clothing",
    image: "https://fakestoreapi.com/img/71HblAHs5xL._AC_UY879_-2.jpg",
    rating: {
      rate: 2,
      count: 679,
    },
  },
  {
    id: 8,
    title: "Short Sleeve Boat V ",
    price: 9.85,
    description:
      "95% RAYON 5% SPANDEX, Made in USA or Imported, Do Not Bleach, Lightweight fabric with great stretch for comfort, Ribbed on sleeves and neckline / Double stitching on bottom hem",
    category: "women's clothing",
    image: "https://fakestoreapi.com/img/71z3kpMAYsL._AC_UY879_.jpg",
    rating: {
      rate: 4.7,
      count: 130,
    },
  },

  {
    id: 9,
    title: "Sleeve Moisture",
    price: 7.95,
    description:
      "100% Polyester, Machine wash, 100% cationic polyester interlock, Machine Wash & Pre Shrunk for a Great Fit, Lightweight, roomy and highly breathable with moisture wicking fabric which helps to keep moisture away, Soft Lightweight Fabric with comfortable V-neck collar and a slimmer fit, delivers a sleek, more feminine silhouette and Added Comfort",
    category: "women's clothing",
    image: "https://fakestoreapi.com/img/51eg55uWmdL._AC_UX679_.jpg",
    rating: {
      rate: 2,
      count: 146,
    },
  },
  {
    id: 1136,
    title: "DANVOUY Casual Cotton Short",
    price: 12.99,
    description:
      "95%Cotton,5%Spandex, Features: Casual, Short Sleeve, Letter Print,V-Neck,Fashion Tees, The fabric is soft and has some stretch., Occasion: Casual/Office/Beach/School/Home/Street. Season: Spring,Summer,Autumn,Winter.",
    category: "women's clothing",
    image: "https://fakestoreapi.com/img/61pHAEJ4NML._AC_UX679_.jpg",
    rating: {
      rate: 3.6,
      count: 145,
    },
  },
  {
    id: 1125,
    title: "Cotton V-neck T Shirt",
    price: 12.99,
    description:
      "95%Cotton,5%Spandex, Features: Casual, Short Sleeve, Letter Print,V-Neck,Fashion Tees, The fabric is soft and has some stretch., Occasion: Casual/Office/Beach/School/Home/Street. Season: Spring,Summer,Autumn,Winter.",
    category: "women's clothing",
    image:
      "https://i5.walmartimages.com/asr/a5e15b0c-c4e9-4943-a495-9ecbec37bd9f_1.5455ecd0d09089578a2c18e709910058.jpeg",
    rating: {
      rate: 3.6,
      count: 145,
    },
  },
  {
    id: 112,
    title: "Long Sleeve Jumper",
    price: 12.99,
    description:
      "95%Cotton,5%Spandex, Features: Casual, Short Sleeve, Letter Print,V-Neck,Fashion Tees, The fabric is soft and has some stretch., Occasion: Casual/Office/Beach/School/Home/Street. Season: Spring,Summer,Autumn,Winter.",
    category: "women's clothing",
    image:
      "https://www.fruitoftheloom.eu/wp-content/uploads/61-404-hd_dark-heather-grey_front.jpg",
    rating: {
      rate: 2,
      count: 145,
    },
  },
];

export const kidsClothes = [
  {
    id: 11,
    title: "premium cotton baby's wear",
    price: 55,
    description:
      "From our Legends Collection, the Naga was inspired by the mythical water dragon that protects the ocean's pearl. Wear facing inward to be bestowed with love and abundance, or outward for protection.",
    category: "jewelery",
    image:
      "https://4.imimg.com/data4/IA/WC/MY-819866/ladies-printed-t-shirt-500x500.jpg",
    rating: {
      rate: 4.6,
      count: 400,
    },

  },
  {
    id: 12,
    title: "pyjamas for your little kido",
    price: 168,
    description:
      "Satisfaction Guaranteed. Return or exchange any order within 30 days.Designed and sold by Hafeez Center in the United States. Satisfaction Guaranteed. Return or exchange any order within 30 days.",
    category: "jewelery",
    image:
      "https://5.imimg.com/data5/SELLER/Default/2021/11/FQ/NT/VO/2190204/s-bp-7-500x500.jpg",
    rating: {
      rate: 3.9,
      count: 70,

    },
  },

  {
    id: 13,
    title: "for your kid Princess",
    price: 9.99,
    description:
      "Classic Created Wedding Engagement Solitaire Diamond Promise Ring for Her. Gifts to spoil your love more for Engagement, Wedding, Anniversary, Valentine's Day...",
    category: "kid's clothing",
    image:
      "https://www.nicepng.com/png/full/245-2451327_he-hello-enjoy-children-clothing-girls-fashion-kids.png",
    rating: {
      rate: 2,
      count: 400,
    },
  },
  {
    id: 14,
    title: "my little Hero",
    price: 10.99,
    description:
      "Rose Gold Plated Double Flared Tunnel Plug Earrings. Made of 316L Stainless Steel",
    category: "kid's clothing",
    image:
      "https://p.kindpng.com/picc/s/733-7333530_child-model-fashion-show-kids-boy-fashion-model.png",
    rating: {
      rate: 1.9,
      count: 100,
    },
  },
  {
    id: 15,
    title: "mom's son",
    price: 64,
    description:
      "USB 3.0 and USB 2.0 Compatibility Fast data transfers Improve PC Performance High Capacity; Compatibility Formatted NTFS for Windows 10, Windows 8.1, Windows 7; Reformatting may be required for other operating systems; Compatibility may vary depending on user's hardware configuration and operating system",
    category: "kid's clothing",
    image:
      "https://previews.123rf.com/images/lufimorgan/lufimorgan1805/lufimorgan180500124/101355046-asian-child-drinking-milk-from-a-glass-and-measuring-himself-on-white-background-isolated.jpg",
    rating: {
      rate: 2,
      count: 203,
    },
  },

  {
    id: 117,
    title: "bundle of love",
    price: 109,
    description:
      "3D NAND flash are applied to deliver high transfer speeds Remarkable transfer speeds that enable faster bootup and improved overall system performance. The advanced SLC Cache Technology allows performance boost and longer lifespan 7mm slim design suitable for Ultrabooks and Ultra-slim notebooks. Supports TRIM command, Garbage Collection technology, RAID, and ECC (Error Checking & Correction) to provide the optimized performance and enhanced reliability.",
    category: "kid's clothing",
    image:
      "https://previews.123rf.com/images/dolgachov/dolgachov1603/dolgachov160302771/53475908-childhood-fashion-and-people-concept-happy-smiling-boy-and-girl-standing-back-to-back.jpg",
    rating: {
      rate: 2,
      count: 319,
    },
  },
  {
    id: 136,
    title: "mom's son",
    price: 64,
    description:
      "USB 3.0 and USB 2.0 Compatibility Fast data transfers Improve PC Performance High Capacity; Compatibility Formatted NTFS for Windows 10, Windows 8.1, Windows 7; Reformatting may be required for other operating systems; Compatibility may vary depending on user's hardware configuration and operating system",
    category: "kid's clothing",
    image:
      "https://previews.123rf.com/images/lufimorgan/lufimorgan1805/lufimorgan180500124/101355046-asian-child-drinking-milk-from-a-glass-and-measuring-himself-on-white-background-isolated.jpg",
    rating: {
      rate: 2,
      count: 203,
    },
  },
  {
    id: 200,
    title: "for your Princess",
    price: 9.99,
    description:
      "Classic Created Wedding Engagement Solitaire Diamond Promise Ring for Her. Gifts to spoil your love more for Engagement, Wedding, Anniversary, Valentine's Day...",
    category: "kid's clothing",
    image:
      "https://www.nicepng.com/png/full/245-2451327_he-hello-enjoy-children-clothing-girls-fashion-kids.png",
    rating: {
      rate: 2,
      count: 400,
    },
  },
];

const allClothes = [...menClothes, ...womenClothes, ...kidsClothes];
export default allClothes;
